import { render, staticRenderFns } from "./DrReport.vue?vue&type=template&id=28060b75&scoped=true&"
import script from "./DrReport.vue?vue&type=script&lang=js&"
export * from "./DrReport.vue?vue&type=script&lang=js&"
import style0 from "./DrReport.vue?vue&type=style&index=0&id=28060b75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28060b75",
  null
  
)

export default component.exports